module.exports = __webpack_public_path__ + "img/contact.ed40f39a.png";